<button
    type="button"
    class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
    style="border: none; width: 36px; height: 36px;"
>
    <i class="black-text fas fa-ellipsis-h mt-0"></i>                                
</button>

<ng-template #content >
    <div class="popover-links popover-links--aligned">
        <div class="popover__action--disabled popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="onClickNotify()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-paper-plane p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Notify Team</span>
            </div>
        </div>        
        <div [class.popover__action--disabled]="allTransactions.length < 1" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="onClickExport()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-arrow-down p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Export Donations</span>
            </div>
        </div>
    </div>
</ng-template>